import { useState, useEffect } from 'react';
import { debounce } from '@utils/helpers';

const useScroll = () => {
  const [isScroll, setIsScroll] = useState(false);
  const [pageTop, setPageTop] = useState(0);

  useEffect(() => {
    const debounceHandleScroll = debounce(handleScroll, 5);
    window.addEventListener('scroll', debounceHandleScroll);
    return () => {
      window.removeEventListener('scroll', debounceHandleScroll);
    };
  }, []);

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    if (scrollTop > 0 && !isScroll) {
      setIsScroll(true);
    } else {
      setIsScroll(false);
    }
    setPageTop(scrollTop);
  };
  return [isScroll, pageTop];
};

export default useScroll;
